import React, { useState } from 'react';
import { FormGroup, Label, Input } from 'reactstrap';
import CustomModal from '../../../../CustomModal';
import { useUnifiedFetch, useUnifiedMutate } from '../../../../../hooks';
import WarningModal from '../../../../WarningModal';
import GlobalLoadingSpinner from '../../../../GlobalLoadingSpinner';

const styles = {
  bodyStyle: { marginTop: '65px' },
  dupMacLabel: {
    marginTop: '2px',
  },
};

const initialValues = {
  dupMacRepair: true,
};

function EpiUtilitiesModal({ isOpen, box, onConfirm, onCancel }) {
  const [formValues, setFormValues] = useState(initialValues);
  const [warningText, setWarningText] = useState();
  const [duplicateMac, setDuplicateMac] = useState(false);
  const {
    fetchData: checkDuplicateMacAddress,
    isLoading: isCheckingDuplicateMacAddress,
  } = useUnifiedFetch(`obis/${box._id}/checkDuplicateMacAddress`, false);
  const { mutate: updateMacAddresses, isLoading: isUpdatingMacAddress } = useUnifiedMutate();

  const handleInputChange = e => {
    switch (e.target.type) {
      case 'radio':
        setFormValues(preValues => ({ ...preValues, [e.target.name]: e.target.checked }));
        break;
      default:
        setFormValues(preValues => ({ ...preValues, [e.target.name]: e.target.value }));
    }
  };

  const handleConfirm = async () => {
    if (formValues.dupMacRepair) {
      const result = await checkDuplicateMacAddress();
      if (result) {
        setWarningText(
          'Duplicate MAC addresses found, do you want to proceed with changing the current MAC addresses on this device ?',
        );
        setDuplicateMac(true)
        return;
      } else {
        setWarningText('No Duplicate MAC Addresses found.');
        setDuplicateMac(false)
      }
    }
  };

  const handleCancelDuplicateMacAddressWarning = () => {
    setWarningText('');
    setDuplicateMac(false)
    onCancel();
  };
  const handleConfirmDuplicateMacAddressWarning = async () => {
    const res = await updateMacAddresses({
      endpoint: `obis/${box._id}/updateDuplicateMacAddress`,
      method: 'PUT',
    });
    if (res) {
      setWarningText('');
      setDuplicateMac(false)
      onConfirm();
    }
  };

  const isLoading = isCheckingDuplicateMacAddress || isUpdatingMacAddress;

  return (
    <>
      <CustomModal
        header="EPI Utilities"
        onConfirm={handleConfirm}
        isOpen={isOpen}
        onCancel={onCancel}
        confirmBtnText="Execute"
        close="Close"
        bodyStyle={styles.bodyStyle}
      >
        <FormGroup check>
          <Input name="dupMacRepair" type="radio" checked onChange={handleInputChange} />
          <Label check style={styles.dupMacLabel}>
            Duplicate MAC Repair
          </Label>
        </FormGroup>
      </CustomModal>
      <WarningModal
        isOpen={Boolean(warningText)}
        onCancel={handleCancelDuplicateMacAddressWarning}
        onConfirm={duplicateMac ? handleConfirmDuplicateMacAddressWarning : undefined}
        body={warningText}
        yesButtonText="Yes"
        noButtonText={duplicateMac ? "No" : 'Close'}
      />
      {isLoading && <GlobalLoadingSpinner />}
    </>
  );
}

export default EpiUtilitiesModal;
